import { useEffect, useState } from "react";
import { Loader2, FileText, Download } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export default function ProspectReportsStrip() {
  const [reports, setReports] = useState(null);
  const [busy, setBusy] = useState(null);

  const load = () => api.get("/prospect/reports").then(({ data }) => setReports(data.reports || [])).catch(() => setReports([]));
  useEffect(() => { load(); }, []);

  const reopen = async (r) => {
    setBusy(r.id);
    try {
      const res = await api.get(`/expenses/business-intelligence/${r.id}/pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Elevare_Assessment_${(r.business_name || "prospect").replace(/[^A-Za-z0-9_-]+/g, "_")}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error("Could not reopen that report."); }
    finally { setBusy(null); }
  };

  const fmt = (iso) => { try { return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" }); } catch { return ""; } };
  if (!reports || !reports.length) return null;

  return (
    <div data-testid="prospect-reports-strip" className="mb-5 rounded-xl border border-[#1e3d3a]/12 bg-white/70 p-4">
      <p className="text-[10px] uppercase tracking-[0.24em] text-[#1e3d3a]/55 mb-2 flex items-center gap-1.5">
        <FileText className="h-3 w-3 text-[#c9a961]" /> Saved prospect reports — reopen without re-running
      </p>
      <div className="flex flex-wrap gap-2">
        {reports.map((r) => (
          <button key={r.id} data-testid={`prospect-report-${r.id}`} onClick={() => reopen(r)} disabled={busy === r.id}
            className="group flex items-center gap-2 rounded-full border border-[#1e3d3a]/15 bg-white px-3 py-1.5 text-xs text-[#1e3d3a]/80 hover:border-[#c9a961] hover:text-[#1e3d3a] transition-colors duration-200 disabled:opacity-60">
            <span className="font-medium truncate max-w-[160px]">{r.business_name}</span>
            <span className="text-[#1e3d3a]/40">{fmt(r.created_at)}</span>
            {busy === r.id ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Download className="h-3.5 w-3.5 text-[#1e3d3a]/25 group-hover:text-[#c9a961]" />}
          </button>
        ))}
      </div>
    </div>
  );
}
